<template>
  <div id="options">
    <Breadcrumbs v-bind="$attrs" :leg-index="legIndex" :flights="flights" @update:is-saved-route="$emit('update:isSavedRoute', false)" @update:leg-index="$emit('update:legIndex', $event)" />
    <FilterSort v-bind="$attrs" v-model:filter="filter" v-model:sort="sort" />
    <List v-bind="$attrs" v-model:filter="filter" v-model:sort="sort" :flights="flights" :leg-index="legIndex" :organization-id="organizationId" :is-dev="isDev" :cache-bust="cacheBust" @reset-filter-sort="resetFilterSort" @error="$emit('error', $event)" @scroll="$emit('scroll', $event)" @update:flights="$emit('update:flights', $event)" @update:is-saved-flights="$emit('update:isSavedFlights', $event)" @update:is-saved-route="$emit('update:isSavedRoute', $event)" @update:is-self-book="$emit('update:isSelfBook', $event)" @update:leg-index="$emit('update:legIndex', $event)" />
    <div id="navigation">
      <a @click="back">Back</a>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import Breadcrumbs from "./TripNewBookFlightsOptionsBreadcrumbs.vue";
import FilterSort from "./TripNewBookFlightsOptionsFlightsFilterSort.vue";
import List from "./TripNewBookFlightsOptionsList.vue";

// Props
defineProps({
  flights: Object,
  legIndex: Number,
  organizationId: [Number, String],
  cacheBust: { type: Number, default: 0 },
});

const urlParams = new URLSearchParams(window.location.search);
const isDev = urlParams.get("debugMode");

// Emits
const emit = defineEmits(["error", "scroll", "update:flights", "update:isSavedFlights", "update:isSavedRoute", "update:isSelfBook", "update:legIndex"]);

// Reactive data for filter and sort
const filter = ref({ depart: "", name: "", policy: false, chaperoned: "Undecided", stops: "" });
const sort = ref("recommended");

// Methods
const back = () => {
  emit("update:isSavedRoute", false);
};

const resetFilterSort = () => {
  filter.value.depart = "";
  filter.value.name = "";
  filter.value.policy = false;
  filter.value.stops = "";
  sort.value = "recommended";
};
</script>
